/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_All_Team_MembersInputs */

const en_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Team Members`)
};

const fr_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les membres de l’équipe`)
};

const de_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Teammitglieder`)
};

const it_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i membri del team`)
};

const ru_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все члены команды`)
};

const es_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los miembros del equipo`)
};

const zh_cn2_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有团队成员`)
};

const ja_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームメンバー全員`)
};

const hi_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी टीम सदस्य`)
};

const pt_pt2_knp_guide_all_team_members = /** @type {(inputs: Knp_Guide_All_Team_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os membros da equipe`)
};

/**
* | output |
* | --- |
* | "All Team Members" |
*
* @param {Knp_Guide_All_Team_MembersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_all_team_members = /** @type {((inputs?: Knp_Guide_All_Team_MembersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_All_Team_MembersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_all_team_members(inputs)
	if (locale === "de") return de_knp_guide_all_team_members(inputs)
	if (locale === "it") return it_knp_guide_all_team_members(inputs)
	if (locale === "ru") return ru_knp_guide_all_team_members(inputs)
	if (locale === "es") return es_knp_guide_all_team_members(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_all_team_members(inputs)
	if (locale === "ja") return ja_knp_guide_all_team_members(inputs)
	if (locale === "hi") return hi_knp_guide_all_team_members(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_all_team_members(inputs)
	return en_knp_guide_all_team_members(inputs)
});